import { render, staticRenderFns } from "./employeeReg.vue?vue&type=template&id=33986a4a&scoped=true"
import script from "./employeeReg.vue?vue&type=script&lang=js"
export * from "./employeeReg.vue?vue&type=script&lang=js"
import style0 from "./employeeReg.vue?vue&type=style&index=0&id=33986a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33986a4a",
  null
  
)

export default component.exports